/* Motivo header: sticky show/hide, mobile drawer, live search, cart count, keyboard menus. No dependencies. */
(function () {
  if (customElements.get('mv-header')) return;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function money(cents) {
    try {
      var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  class MvHeader extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section') || this.parentElement;
      this.drawer = this.querySelector('[data-mv-drawer]');
      this.search = this.querySelector('[data-mv-search]');
      this.scrim = this.querySelector('[data-mv-scrim]');
      this.input = this.querySelector('[data-mv-search-input]');
      this.results = this.querySelector('[data-mv-search-results]');
      this.popular = this.querySelector('[data-mv-search-popular]');
      this.onKey = this.onKey.bind(this);

      this.addEventListener('click', this.onClick.bind(this));
      if (this.scrim) this.scrim.addEventListener('click', this.closeAll.bind(this));
      if (this.drawer) this.drawer.addEventListener('click', function (e) { if (e.target === this.drawer) this.closeDrawer(); }.bind(this));
      if (this.input) this.input.addEventListener('input', this.onInput.bind(this));

      this.initSticky();
      this.initMenus();
      this.initCount();
    }

    /* ---- Sticky: hide on scroll down, show on scroll up ---- */
    initSticky() {
      if (this.dataset.sticky !== 'true' || !this.section) return;
      var last = window.scrollY, ticking = false, sec = this.section, self = this;
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var y = window.scrollY;
          var open = self.classList.contains('is-busy');
          if (!open) sec.classList.toggle('is-hidden', y > last && y > sec.offsetHeight + 120);
          last = y;
          ticking = false;
        });
      }, { passive: true });
    }

    /* ---- Desktop dropdowns: keyboard + touch support (hover is CSS) ---- */
    initMenus() {
      var self = this;
      this.querySelectorAll('.mv-hdr__item.has-panel').forEach(function (item) {
        var link = item.querySelector('.mv-hdr__link');
        item.addEventListener('mouseleave', function () { item.classList.remove('is-open'); link.setAttribute('aria-expanded', 'false'); });
        item.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget)) { item.classList.remove('is-open'); link.setAttribute('aria-expanded', 'false'); } });
        link.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowDown' || e.key === ' ') { e.preventDefault(); self.openPanel(item, link); var f = item.querySelector('.mv-hdr__panel a'); if (f) f.focus(); }
        });
        /* Touch screens: first tap opens the panel, second tap follows the link */
        link.addEventListener('click', function (e) {
          if (window.matchMedia('(hover: none)').matches && !item.classList.contains('is-open')) { e.preventDefault(); self.openPanel(item, link); }
        });
      });
    }
    openPanel(item, link) {
      this.querySelectorAll('.mv-hdr__item.is-open').forEach(function (i) { i.classList.remove('is-open'); });
      item.classList.add('is-open');
      link.setAttribute('aria-expanded', 'true');
    }

    /* ---- Cart count follows the Motivo cart drawer ---- */
    initCount() {
      var badge = this.querySelector('[data-mv-cart-count]');
      var cartLink = this.querySelector('[data-mv-cart-link]');
      if (!badge) return;
      var set = function (n) {
        n = parseInt(n, 10) || 0;
        badge.textContent = n;
        badge.hidden = n === 0;
        if (cartLink) cartLink.setAttribute('aria-label', 'Cart, ' + n + (n === 1 ? ' item' : ' items'));
      };
      var watch = function () {
        var d = document.querySelector('mv-cart-drawer');
        if (!d) return false;
        new MutationObserver(function () { set(d.dataset.count); }).observe(d, { attributes: true, attributeFilter: ['data-count'] });
        return true;
      };
      if (!watch()) document.addEventListener('DOMContentLoaded', watch, { once: true });
      document.addEventListener('mv:cart:updated', function (e) { if (e.detail && typeof e.detail.item_count === 'number') set(e.detail.item_count); });
    }

    /* ---- Clicks ---- */
    onClick(e) {
      var t = e.target;
      if (t.closest('[data-mv-drawer-open]')) { e.preventDefault(); this.openDrawer(); }
      else if (t.closest('[data-mv-drawer-close]')) { e.preventDefault(); this.closeDrawer(); }
      else if (t.closest('[data-mv-search-open]')) { e.preventDefault(); this.openSearch(); }
      else if (t.closest('[data-mv-search-close]')) { e.preventDefault(); this.closeSearch(); }
    }
    onKey(e) {
      if (e.key === 'Escape') this.closeAll();
    }
    closeAll() { this.closeSearch(); this.closeDrawer(); }

    openDrawer() {
      if (!this.drawer) return;
      this.closeSearch();
      this.drawer.hidden = false;
      void this.drawer.offsetWidth;
      this.drawer.classList.add('is-open');
      document.documentElement.classList.add('mv-lock');
      this.classList.add('is-busy');
      var b = this.querySelector('[data-mv-drawer-open]');
      if (b) b.setAttribute('aria-expanded', 'true');
      document.addEventListener('keydown', this.onKey);
      var c = this.drawer.querySelector('[data-mv-drawer-close]');
      if (c) c.focus();
    }
    closeDrawer() {
      if (!this.drawer || this.drawer.hidden) return;
      var d = this.drawer;
      d.classList.remove('is-open');
      document.documentElement.classList.remove('mv-lock');
      this.classList.remove('is-busy');
      var b = this.querySelector('[data-mv-drawer-open]');
      if (b) { b.setAttribute('aria-expanded', 'false'); b.focus(); }
      document.removeEventListener('keydown', this.onKey);
      setTimeout(function () { if (!d.classList.contains('is-open')) d.hidden = true; }, 320);
    }

    openSearch() {
      if (!this.search) return;
      this.closeDrawer();
      this.search.hidden = false;
      if (this.scrim) this.scrim.hidden = false;
      this.classList.add('is-busy');
      if (this.section) this.section.classList.remove('is-hidden');
      document.addEventListener('keydown', this.onKey);
      var input = this.input;
      setTimeout(function () { if (input) input.focus(); }, 30);
    }
    closeSearch() {
      if (!this.search || this.search.hidden) return;
      this.search.hidden = true;
      if (this.scrim) this.scrim.hidden = true;
      this.classList.remove('is-busy');
      document.removeEventListener('keydown', this.onKey);
    }

    /* ---- Live search (Shopify predictive search) ---- */
    onInput() {
      clearTimeout(this._t);
      var q = this.input.value.trim();
      if (this.popular) this.popular.hidden = q.length > 0;
      if (!q) { this.results.innerHTML = ''; return; }
      this._t = setTimeout(this.fetchResults.bind(this, q), 180);
    }
    fetchResults(q) {
      var self = this;
      if (this._ctrl) this._ctrl.abort();
      this._ctrl = 'AbortController' in window ? new AbortController() : null;
      var url = ROOT + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url, this._ctrl ? { signal: this._ctrl.signal } : {})
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var items = (data.resources && data.resources.results && data.resources.results.products) || [];
          var all = ROOT + 'search?q=' + encodeURIComponent(q) + '&options[prefix]=last';
          if (!items.length) { self.results.innerHTML = '<p class="mv-search__empty">No products found for “' + esc(q) + '”.</p>'; return; }
          self.results.innerHTML = '<ul class="mv-search__list" role="list">' + items.map(function (p) {
            var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
            if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=120';
            var price = p.price != null && p.price !== '' ? money(Math.round(parseFloat(p.price) * 100)) : '';
            return '<li><a class="mv-search__hit" href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" width="56" height="56" loading="lazy">' : '') +
              '<span><span class="mv-search__hit-title">' + esc(p.title) + '</span><span class="mv-search__hit-price">' + esc(price) + '</span></span></a></li>';
          }).join('') + '</ul><a class="mv-search__all" href="' + esc(all) + '">See all results</a>';
        })
        .catch(function () {});
    }
  }

  customElements.define('mv-header', MvHeader);
})();
